import styles from '@/pages/CashPage.module.css'

interface Props {
  total: number
  online: number
  offline: number
  problems: number
  loading?: boolean
  onProblemsClick?: () => void
}

export function CashKpi({ total, online, offline, problems, loading, onProblemsClick }: Props) {
  const cards: {
    label: string
    value: string | number
    tone?: 'success' | 'danger' | 'warning'
    onClick?: () => void
  }[] = [
    { label: 'Всего', value: loading ? '—' : total },
    { label: 'Онлайн', value: loading ? '—' : online, tone: 'success' },
    {
      label: 'Оффлайн',
      value: loading ? '—' : offline,
      tone: offline > 0 ? 'danger' : undefined,
    },
    {
      label: 'Внимание',
      value: loading ? '—' : problems,
      tone: problems > 0 ? 'warning' : undefined,
      onClick: problems > 0 ? onProblemsClick : undefined,
    },
  ]

  return (
    <div className={`${styles.kpi} ${loading ? styles.kpiLoading : ''}`}>
      {cards.map((c) => (
        <button
          key={c.label}
          type="button"
          className={`${styles.kpiCard} ${c.onClick ? styles.kpiClickable : ''}`}
          onClick={c.onClick}
          disabled={!c.onClick}
        >
          <div className={styles.kpiTop}>
            {c.tone ? <span className={`${styles.kpiDot} ${styles[`kpiDot_${c.tone}`]}`} /> : null}
            <span className={styles.kpiLabel}>{c.label}</span>
          </div>
          <div
            className={[
              styles.kpiValue,
              c.tone === 'success' ? styles.kpiSuccess : '',
              c.tone === 'danger' ? styles.kpiDanger : '',
              c.tone === 'warning' ? styles.kpiWarning : '',
            ]
              .filter(Boolean)
              .join(' ')}
          >
            {c.value}
          </div>
        </button>
      ))}
    </div>
  )
}
